<template>
    <div>
		<div class="header">
	      <p class="size">企业管理</p>
	     <el-button type="primary"  style="height: 35px;line-height: 10px;margin-right: 20px;"  @click="AddCompany">+ 新增企业</el-button>
	  </div>
	  <el-form :inline="true" :model="formInline" 	ref="form" class="demo-form-inline" style="text-align: left;">
		  <el-form-item label="企业名称">
		    <el-input v-model="formInline.user" placeholder="请输入企业名称"></el-input>
		  </el-form-item>
			<div class="asd">
				<el-form-item label="时间范围">
				  		<el-date-picker :clearable="false"  type="date" placeholder="选择查询起始时间" v-model="formInline.date1" style="width: 40%;" value-format="yyyy-MM-dd"></el-date-picker>
          -
          <el-date-picker :clearable="false"  type="date" placeholder="选择查询起始时间" v-model="formInline.date2" style="width: 40%;" value-format="yyyy-MM-dd"></el-date-picker>
				 </el-form-item>
				 <el-form-item style="margin-right: 20px;">
						<el-button type="primary" style="height: 35px;line-height: 10px;"  @click="Selected">查询</el-button>
						<el-button type="info" style="height: 35px;line-height: 10px;"  @click="resetForm">重置</el-button>
					</el-form-item>

				</div>

			</el-form>

      	<el-table
      	:header-cell-style="cell"
		    :data="tableDatas"
         stripe
		    style="width: 100%;margin-top: 20px;">
		    <el-table-column
		      prop="name"
		      label="企业名称"
					align="center"
		     >
		    </el-table-column>

		    <el-table-column
		      prop="createTime"
		      label="创建时间"
					align="center"
		     >
		    </el-table-column>
		     <el-table-column
		      prop="phone"
		      label="联系方式"
					align="center"
		      >

		    </el-table-column>
		    <el-table-column
          :formatter="tofixed"
		      prop="account"
		      label="企业钱包余额"
					align="center"
		      >
		    </el-table-column>

		     <el-table-column label="操作"   align="center">
		      <template slot-scope="scope" >
		        <el-button
		          size="medium"
		          type="text"
		          @click="handleCompile(scope.$index, scope.row)">编辑</el-button>
						<el-button
						style="color: red;"
						size="medium"
						type="text"
						@click="handleDelete(scope.row.name,scope.row.id,3)">删除</el-button>
					<el-button
						v-if="1 == scope.row.status"
						style="color: red"
						size="medium"
						type="text"
						@click="handleDelete(scope.row.name,scope.row.id,2)"	>封号</el-button>
					<el-button
						v-else-if="2 == scope.row.status"
						size="medium"
						type="text"
						@click="handleDelete(scope.row.name,scope.row.id,1)"	>解封</el-button>

		      </template>
		    </el-table-column>
	  </el-table>
      <div class="pageWrap">
        <el-pagination
              background
              layout="prev,pager,next,jumper"
             :current-page.sync="currentPage"
             @current-change="handleCurrentChange"
             @size-change="handleSizeChange"
             :page-size="pageSize"
             :total='total'
                ></el-pagination>
      </div>
    </div>
</template>

<script>
import {
  getComAll,
  delCompany,
  SelectAll
} from "../../api/companyApi/company";
import { toFixed,compareTime } from "@/utils";
export default {
  name: "",
  props: [""],
  data() {
    return {
      currentPage: 1,
      page: 1,
      pageSize: 5,
      unlik: true,
      total: 0,
      flag: true,
      dialogFormVisible: false,
      Rino: false,
      Delete: false,
      jieFeng: false,
      name1: "",
      formLabelWidth: "120px",
      formInline: {
        user: "",
        date1: '',
        date2: '',
        start: "",
        end: ""
      },
      tableDatas: []
    };
  },
  methods: {
    AddCompany: function() {
      this.$router.push({ name: "新增企业" });
    },
     tofixed(row,column,cellValue) {
      return toFixed(cellValue)
    },
    // 删除商户
    handleDelete(name,id, type) {
      let msg = "";
       let _this = this;
      switch (type) {
        case 1:
          {
            msg = "是否解封 “"+name+"” ？";
          }
          break;
        case 2:
          {
            msg = "确定封号 “"+name+"” ，封号后可进行解封";
          }
          break;
        case 3:
          {
            msg = "确定删除企业 “"+name+" ”，删除后不可撤销";
          }
          break;
        default: {
          msg = "确认进行此操作？";
        }
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delCompany(id, type).then(res => {
              if (1 === type || 2 === type) {
                this._updateData(id, type);
              }
              this.$message({
                type: "success",
                message: "操作成功!"
              });
                _this.getCompanyAll(_this.currentPage,_this.pageSize);
            })
            .catch(error => {
              let msg = "请求出错！";
              if (error.response.data) {
                msg = error.response.data.msg || "请求出错";
              }
              this.$message({
                type: "warning",
                message: msg
              });
            });
        })
        .catch(() => {
          switch (type) {
            case 1:
              {
                this.$message({
                  type: "info",
                  message: "已取消解封"
                });
              }
              break;
            case 2:
              {
                this.$message({
                  type: "info",
                  message: "已取消封号"
                });
              }
              break;
            case 3:
              {
                this.$message({
                  type: "info",
                  message: "已取消删除"
                });
              }
              break;
          }
        });
    },
    _updateData(id, type) {
      let len = this.tableDatas.length;
      let updateData = this.tableDatas;
      let status = 0;
      for (let i = 0; i < len; i++) {
        let comId = updateData[i].id;
        if (id === comId) {
          updateData[i]["status"] = type;
        }
      }
      this.tableDatas = updateData;
    },
    onSubmit() {
      console.log("submit!");
    },
    handleCompile(index, row) {
      this.$router.push({ name: "新增企业", params: { companyId: row.id } });
    },
    cell() {
      return { textAlign: "center" ,background:"#FAFAFA"};
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getCompanyAll(page, this.pageSize);
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
    },
    //获取列表所有数据
    getCompanyAll(page,rows) {
      let _this = this;
      let companyName = this.formInline.user;
      let end = this.formInline.date2;
      let start = this.formInline.date1;
      // if(flag||""){
        getComAll(companyName, end, page, rows, start)
          .then(response => {
            this.total = response.data.count;
            this.tableDatas = response.data.companyList;
          })
          .catch(error => {
            // this.$message({
            //   type:"error",
            //   message:"抱歉，您没有当前模块的访问权限"
            // })
            //this._notify("请求出错,请重试", "warning");
          });
      //}else{
       // this._notify("请正确选择时间", "warning");
     // }

    },
    //通知框
    _notify(message = "提示", type = "success") {
      this.$notify({
        title: "提示",
        message,
        type,
        duration: 800
      });
    },
    // 重置
    resetForm() {
      this.formInline = {
        user: "",
        range: [],
        start: "",
        end: ""
      };
       this.currentPage=1;
      this.getCompanyAll(1,5);
    },
    //查询企业
    Selected() {
      let end = this.formInline.date2;
      let start = this.formInline.date1;
      let flag = compareTime(start,end);
      if(start!=null&&end!=null){
          if(flag){
                this.tableDatas = [];
                this.getCompanyAll();
          }else{
               this._notify("请正确选择时间", "warning");
          }
      }else{  
          this.tableDatas = [];
          this.getCompanyAll();     
      }
   

    }
  },
  created() {
     let page = this.currentPage;
    let rows = this.pageSize;
    this.getCompanyAll(page,rows);
  }
};
</script>
<style scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.asd {
  display: flex;
  justify-content: space-between;
}
.pageWrap {
  margin-top: 20px;
  text-align: center;
}
.size{
  font-size: 18px
}
</style>



// WEBPACK FOOTER //
// src/pages/company/index.vue